import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Avatar from '@material-ui/core/Avatar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import { withRouter } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Cookies } from 'react-cookie';
import Grid from '@material-ui/core/Grid';
import logo from '../../assets/pictures/dishop.png';
import * as actions from '../../actions/index';
import { mainColor, UNIT } from '../../constants/theme';
import { signInUser, resetPasswordUser } from '../../apis/firebase';
import { Input, Button } from '../../components';
import { renderErrorMessage } from '../../utils/errors';
import { isStringNotNull } from '../../utils/tools';
import { RESET_PASSWORD_MESSAGE, ERROR_WRONG_INFORMATIONS } from '../../constants';
import { styles } from './SignIn.styles';
const modalDataError = {
  color: 'danger',
  btnColor: 'danger'
};


class SignIn extends Component {
  state = {
    email: '',
    password: '',
    shopId: '',
    isLoading: false,
    forgotPassword: false
  };

  handleChange = ({ target }) => {
    const { isLoading } = this.state;
    if (!isLoading) {
      this.setState({ [target.id]: target.value });
    }
  };

  handleForgotPassword = () => {
    this.setState({ forgotPassword: true });
  };

  handleForgotPasswordGoBack = () => {
    this.setState({ forgotPassword: false });
  };

  handleResetPassword = async event => {
    const { shopId, email } = this.state;
    const { showModal } = this.props;
    event.preventDefault();
    this.setState({ isLoading: true });
    try {
      if (!isStringNotNull(email) || !isStringNotNull(shopId)) {
        throw ERROR_WRONG_INFORMATIONS;
      } else {
        await resetPasswordUser(email, shopId);
        const modalData = {
          title: RESET_PASSWORD_MESSAGE
        };
        showModal(modalData);
        this.setState({ isLoading: false, forgotPassword: false });
      }
    } catch (error) {
      this.setState({ isLoading: false });
      const modalData = {
        title: renderErrorMessage(error),
        ...modalDataError
      };
      showModal(modalData);
    }
  };

  handleSignIn = async event => {
    const { email, password, shopId } = this.state;
    const { showModal } = this.props;
    event.preventDefault();
    this.setState({ isLoading: true });
    try {
      if (!isStringNotNull(email) || !isStringNotNull(password) || !isStringNotNull(shopId)) {
        throw ERROR_WRONG_INFORMATIONS;
      } else {
        const id = new Cookies().get('shopId');
        if (id) window.location.reload();
        else {
          await signInUser(email, password, shopId);
        }
      }
    } catch (error) {
      this.setState({ isLoading: false });
      const modalData = {
        title: renderErrorMessage(error),
        ...modalDataError
      };
      showModal(modalData);
    }
  };
   
  render() {
    const { classes } = this.props;
    const { email, password, shopId, forgotPassword, isLoading } = this.state;
    const helpLink = 'https://noteforms.com/forms/vous-avez-besoin-daide-3wqvs8';
    return (
      <Grid container component="main" className={classes.root}>
        <CssBaseline />
        <Grid item xs={false} sm={4} md={7} className={classes.image} />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <div className={classes.paper}>
            <Avatar className={classes.avatar} alt="dishop" src={logo} />
            <Typography component="h1" variant="h4" align="center">
              {!forgotPassword ? 'Connexion' : 'Réinitialisation de votre mot de passe'}
            </Typography>
            <form className={classes.form}>
              <>
                <Input
                  onChange={this.handleChange}
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  value={email}
                />
                {!forgotPassword && (
                  <Input
                    onChange={this.handleChange}
                    value={password}
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="Mot de passe"
                    type="password"
                    id="password"
                    autoComplete="current-password"
                  />
                )}
                <Input
                  onChange={this.handleChange}
                  margin="normal"
                  required
                  fullWidth
                  label="Identifiant magasin"
                  name="shopId"
                  type="shopId"
                  id="shopId"
                  autoComplete="shop-Id"
                  value={shopId}
                />
              </>

              {isLoading ? (
                <center>
                  <CircularProgress
                    style={{
                      marginTop: UNIT * 2,
                      textAlign: 'center',
                      color: `rgba(${mainColor.red}, ${mainColor.green}, ${mainColor.blue}, 1)`
                    }}
                  />
                </center>
              ) : (
                <>
                  <div className="d-flex justify-content-center pt-4">
                    <Button
                      type="submit"
                      color="success"
                      className={!forgotPassword ? 'w-75' : 'w-50'}
                      onClick={!forgotPassword ? this.handleSignIn : this.handleResetPassword}
                    >
                      {!forgotPassword ? 'Connexion' : 'Valider'}
                    </Button>
                  </div>
                  <div className="d-flex justify-content-center pt-4">
                    <Button
                      type="submit"
                      color="secondary"
                      outlined="true"
                      className={!forgotPassword ? 'w-26' : 'w-50'}
                      onClick={
                        !forgotPassword
                          ? this.handleForgotPassword
                          : this.handleForgotPasswordGoBack
                      }
                    >
                      {!forgotPassword ? 'Mot de passe oublié ? ' : 'Retour'}
                    </Button>
                  </div>
                  <div className="d-flex justify-content-center pt-4">
                    <a href={helpLink} target="_blank" rel="noopener noreferrer" className={classes.link}>
                     Besoin d'aide ?
                    </a>
                  </div>
                </>
              )}
            </form>
          </div>
        </Grid>
      </Grid>
    );
  }
}

SignIn.propTypes = {
  classes: PropTypes.element.isRequired
};

export default connect(null, actions)(withStyles(styles)(withRouter(SignIn)));
